<template>
    <template v-if="this.type == 'interview'">
        <div
            class="video-pop-up-button-container"
            @click="this.video_popup.show = true"
        >
            <div class="video-pop-up-button">
                <div class="img-part">
                    <div
                        class="img"
                        :style="`background-image:url('${this.imgSrc}')`"
                    ></div>
                    <!-- <img
                        :src="this.imgSrc"
                        alt=""
                    /> -->
                </div>
                <div class="text-part">
                    <div class="text-part__row name">{{ this.name }}</div>
                    <div class="text-part__row role">{{ this.role }}</div>
                    <div class="text-part__row button">인터뷰 확인하기</div>
                </div>
            </div>
        </div>
        <Transition>
            <div
                class="pop-up"
                :id="`video-popup-${this.videoId}`"
                v-show="this.video_popup.show"
            >
                <div class="pop-up__closer">
                    <div class="pop-up__closer__line pop-up__closer__line--left"></div>
                    <div class="pop-up__closer__line pop-up__closer__line--right"></div>
                </div>
                <div
                    class="video-container"
                    :id="`video-${this.videoId}`"
                >
                    <div
                        class="video"
                        ref="video"
                    ></div>
                    <div
                        class="caption"
                        v-if="this.caption"
                    >
                        {{ this.caption }}
                    </div>
                </div>
            </div>
        </Transition>
    </template>
    <div
        v-else
        :class="[`video-container`, this.type == 'main_video' ? 'main-video' : null]"
        :id="`video-${this.videoId}`"
    >
        <div
            class="loading"
            v-if="this.loading"
        ></div>
        <div
            ref="video"
            class="video"
        ></div>
        <div
            class="caption"
            v-if="this.caption"
        >
            {{ this.caption }}
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    name: 'bmVideo',
    data() {
        return {
            loading: false,
            the_player: null,
            name: null,
            role: null,
            video_popup: {
                show: false,
            },
        };
    },
    props: {
        type: { type: String, default: 'normal' },
        imgSrc: { type: null },
        videoId: {
            type: null,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: true,
        },
        controls: {
            type: Boolean,
            default: true,
        },
        replay: {
            type: Boolean,
            default: false,
        },
        reveal: {
            type: Boolean,
            default: true,
        },
        class: {
            type: String,
            default: null,
        },
        caption: {
            type: String,
            default: null,
        },
        cctv: {
            type: Boolean,
            default: false,
        },
        mainVideo: {
            type: Boolean,
            default: false,
        },
        interview: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        exitPopup() {
            this.video_popup.show = false;
            // let iframe = document.querySelector(`#video-popup-${this.videoId} iframe`);
            // let player = new this.Vimeo.player(iframe);
            // console.log(player);
        },
        main_video_function(player) {
            let _self = this;

            player.setMuted(true).then(function () {
                player.play();

                let target = document.querySelector(`#video-${_self.videoId} .video iframe`);

                let width = target.getAttribute('width');
                let height = target.getAttribute('height');
                let ratio = width / height;

                target.removeAttribute('width');
                target.removeAttribute('height');

                if (innerWidth / innerHeight >= ratio) {
                    target.style.width = document.querySelector(`#video-${_self.videoId} .video`).offsetWidth + 'px';
                    target.style.height = document.querySelector(`#video-${_self.videoId} .video`).offsetWidth * ratio + 'px';
                } else {
                    // 위아래가 긴경우
                    target.style.width = document.querySelector(`#video-${_self.videoId} .video`).offsetHeight * ratio + 'px';
                    target.style.height = document.querySelector(`#video-${_self.videoId} .video`).offsetHeight + 'px';
                }

                window.addEventListener('resize', function () {
                    if (innerWidth / innerHeight >= ratio) {
                        target.style.width = document.querySelector(`#video-${_self.videoId} .video`).offsetWidth + 'px';
                        target.style.height = document.querySelector(`#video-${_self.videoId} .video`).offsetWidth * ratio + 'px';
                    } else {
                        // 위아래가 긴경우
                        target.style.width = document.querySelector(`#video-${_self.videoId} .video`).offsetHeight * ratio + 'px';
                        target.style.height = document.querySelector(`#video-${_self.videoId} .video`).offsetHeight + 'px';
                    }
                });
            });
        },
    },
    mounted() {
        let _self = this;
        let player = null;

        switch (this.type) {
            // 인터뷰인 경우
            case 'interview':
                _self.name = _self.caption.split('/')[0];
                _self.role = _self.caption.split('/')[1];

                player = new this.Player(this.$refs['video'], {
                    id: this.videoId,
                    responsive: true,
                    autoplay: false,
                    muted: false,
                    loop: this.loop,
                    controls: this.controls,
                });

                $(`.pop-up__closer`).click(() => {
                    _self.video_popup.show = false;
                    player.pause();
                });

                break;
            // 메인비디오인 경우
            case 'main_video':
                this.loading = true;
                player = new this.Player(this.$refs['video'], {
                    id: this.videoId,
                    responsive: false,
                    autoplay: false,
                    muted: false,
                    loop: this.loop,
                    controls: this.controls,
                });

                player.on('loaded', () => {
                    _self.loading = false;
                    _self.main_video_function(player);
                });

                break;
            // 일반비디오의 경우
            case 'normal':
                player = new this.Player(this.$refs['video'], {
                    id: this.videoId,
                    responsive: true,
                    autoplay: false,
                    muted: false,
                    loop: this.loop,
                    controls: this.controls,
                });

                player.on('loaded', function () {
                    _self.loading = false;

                    if (!_self.cctv) {
                        _self.ScrollReveal().reveal(`#video-${_self.videoId}`, {
                            reset: true,
                            origin: 'bottom',
                            distance: '1em',
                            reset: true,
                            duration: 1200,
                            beforeReset() {
                                player.pause();
                            },
                            afterReveal() {
                                player.setMuted(true).then(function () {
                                    player.play();
                                });
                            },
                        });
                    }
                });

                break;
        }
    },
};
</script>

<style lang="scss" scoped>
.video-container {
    position: relative;
}
.loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: black;
    z-index: 9;
}
.video-pop-up-button-container {
    overflow: hidden;
    border-radius: 10px;
    max-width: 440px;
    margin: 0 auto;
    margin-bottom: 100px;
    padding: 20px;
}
.video-pop-up-button {
    display: grid;
    grid-template-columns: 100px 1fr;
    border-radius: 5px;
    background: $white;
    color: $black;
    box-shadow: inset 0px -10px 0px 0px rgb(200, 200, 200);
    cursor: pointer;
    align-self: end;
    border-radius: 10px;
    transition: transform 0.2s;
    &:hover {
        transform: translateY(5px);
    }
    .img-part {
        display: flex;
        padding: 10px;
        padding-bottom: 20px;
        .img {
            width: 100%;
            background-size: cover;
            background-position: center center;
        }
    }

    .text-part {
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 20px;
        .name {
            font-weight: 600;
            border-bottom: 1px solid $black;
            margin-bottom: 5px;
        }
        .role {
            font-size: 0.8em;
        }
        .button {
            background: rgb(180, 180, 180);
            color: $white;
            font-size: 0.8em;
            padding: 5px;
            text-align: center;
            border-radius: 5px;
        }
    }
}

.pop-up {
    .video-container {
        max-width: 1200px;
        margin-bottom: 0;
        .caption {
            color: $white;
        }
    }
    .video {
        width: 100%;
    }
}
</style>
